import { Injectable } from '@angular/core';
import { MantenimientoCampanyasFilters } from '../models/mantenimiento-campanyas-filters.model';
import { MantenimientoDenominacionesFilters } from '../models/mantenimiento-denominaciones-filters';
import { MantenimientoMarcasFilters } from '../models/mantenimiento-marcas-filters.model';
import { MantenimientoProductosFilters, ProductoIdiomaFilters } from '../models/mantenimiento-productos-filters.model';

@Injectable()
export class GestionContextService {
    public mantenimientoMarcasFilters: MantenimientoMarcasFilters;
    public mantenimientoProductosFilters: MantenimientoProductosFilters;
    public productosIdiomaFilters: ProductoIdiomaFilters;
    public mantenimientoCampanyasFilters: MantenimientoCampanyasFilters;
    public mantenimientoDenominacionesFilters: MantenimientoDenominacionesFilters;
}